import React from 'react';
import { StyledListVoiceCard } from './index.style';
import VoiceCard from './VoiceCard';

const ListVoiceCard = ({ communityVoicesData }) => (
  <StyledListVoiceCard>
    {communityVoicesData?.map((voice) => (
      <VoiceCard key={voice.id} voiceData={voice} />
    ))}
  </StyledListVoiceCard>
);

export default ListVoiceCard;
